/**
 * As iniciais do avatar dourado (UX-DR2).
 *
 * Regra: uma palavra vira uma letra, duas ou mais viram a **primeira e a ultima** — "Gustavo
 * Bastos" e `GB`, "Ana Paula Souza" e `AS`. Nome vazio ou so com espacos vira `?`, e nao
 * string vazia: um avatar em branco parece defeito de carregamento, e o `?` diz que o nome
 * nao veio. Render de tela nunca quebra por causa de um nome.
 */

/** Iniciais de um nome, sempre com 1 ou 2 letras maiusculas. */
export function iniciaisDoNome(nome: string): string {
  const palavras = nome.trim().split(/\s+/).filter(Boolean)

  if (palavras.length === 0) {
    return '?'
  }

  const primeira = palavras[0] ?? ''
  const ultima = palavras[palavras.length - 1] ?? ''

  const letras = palavras.length === 1 ? primeira.slice(0, 1) : primeira.slice(0, 1) + ultima.slice(0, 1)

  // `toLocaleUpperCase('pt-BR')` e nao `toUpperCase()`: o acento do nome ("Ãngela") sobe
  // certo, e a regra do turco para o "i" nunca se aplica a um nome brasileiro.
  return letras.toLocaleUpperCase('pt-BR')
}
